import { JSONSchema7 } from 'json-schema';
import { emailRegex, Form, nameRegex } from './form';
import { Text } from '../index';

export interface FLashSaleForm extends Form {
  clientFunction: string;
  clientCategory: string;
  agencyRef: string;
  agencyQuery: string;
  agencyID: string;
  postalCode?: string;
  emailRedirection: string;
  recipt: Text[];
}

export const FLASH_SALE_FORM: JSONSchema7 = {
  properties: {
    civilTitle: {
      type: 'string',
      enum: ['M', 'Mme'],
      minLength: 1,
    },
    firstName: {
      type: 'string',
      pattern: nameRegex,
      minLength: 1,
    },
    lastName: {
      type: 'string',
      pattern: nameRegex,
      minLength: 1,
    },
    email: {
      type: 'string',
      pattern: emailRegex,
      minLength: 1,
    },
    phone: {
      type: 'string',
      pattern: '^$|^[0-9]{10}$',
      minLength: 1,
    },
    postalCode: {
      type: 'string',
      minLength: 1,
      pattern: '^$|^[0-9]{5}$',
      maxLength: 5,
    },
    recaptcha: {
      type: 'string',
      minLength: 1,
    },
    emailRedirection: {
      type: 'string',
      minLength: 1,
    },
    textRadioButton: {
      type: 'boolean',
      enum: [true],
    },
    recipt: {
      type: 'array',
    },
    providerCode: {
      type: 'string',
      minLength: 1,
    },
  },
  required: [
    'civilTitle',
    'firstName',
    'lastName',
    'email',
    'phone',
    'postalCode',
    'recaptcha',
    'emailRedirection',
    'textRadioButton',
    'providerCode',
  ],
};

export const FLASH_SALE_FORM_BACKEND_VALIDATION_SCHEMA: JSONSchema7 = {
  properties: {
    civilTitle: {
      type: 'string',
      enum: ['M', 'Mme'],
      minLength: 1,
    },
    firstName: {
      type: 'string',
      pattern: nameRegex,
      minLength: 1,
    },
    lastName: {
      type: 'string',
      pattern: nameRegex,
      minLength: 1,
    },
    email: {
      type: 'string',
      pattern: emailRegex,
      minLength: 1,
    },
    phone: {
      type: 'string',
      pattern: '^$|^[0-9]{10}$',
      minLength: 1,
    },
    postalCode: {
      type: 'string',
      minLength: 1,
      pattern: '^$|^[0-9]{5}$',
      maxLength: 5,
    },
    recaptcha: {
      type: 'string',
      minLength: 1,
    },
    emailRedirection: {
      type: 'string',
      minLength: 1,
    },

    providerCode: {
      type: 'string',
      minLength: 1,
    },
  },
  required: [
    'civilTitle',
    'firstName',
    'lastName',
    'email',
    'phone',
    'postalCode',
    'providerCode',
    'recaptcha',
    'emailRedirection',
  ],
};
